<template>
  <div id="thank-you">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="'Thank you'"/>
     <a-card>
      <h3>Thank you for your TELAS registration.
        Please check your inbox to
        confirm your registration and then
        login to complete a user profile
      </h3>
    </a-card>
  </div>
</template>
<script>
import dashHeader from '@src/views/dashboard/Header.vue';

export default {
  name: 'thank-you',
  data() {
    return {
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Register',
          route: '/register',
        },
        {
          name: 'Thank you',
          route: '/thank-you',
        },
      ],
    };
  },
  components: {
    dashHeader,
  },
};
</script>
